import { axios_ } from "@/tools/axios_";
import encrypt from "@/tools/encrypt";
import { doGetRequest, doPostRequest } from "../../../tools/axios_";
function clearAllLocalStorage() {
    Object.keys(localStorage).forEach(function(key) {
      localStorage.removeItem(key);
    });
}
// 用户协议获取验证吗
export const sendAgreementSMSCode = async (phone, token) => {
    const res = await axios_({
      url: "/api/organization/tenant/user/sendAgreementCaptcha",
      method: 'get',
      headers: {
        'access-token': token
     },
      params: {
        phone,
        source: 'tenant_pc',
      },
    });
    return res.data;
  }

export const getMerchantList = async (params, grantType) => {
  const res = await axios_({
    url: `/api/organization/oauth/org/${grantType}`,
    method: 'post',
    data: params
  });
  return res.data;
};

export const getMerchantToken = async (params, grantType) => {
  const res = await axios_({
    url: `/api/organization/oauth/token/${grantType}`,
    method: 'post',
    data: params
  });
  return res.data;
};

export const unifiedPassword = async (params, grantType) => {
  const res = await axios_({
    url: `/api/organization/tenant/user/unifiedPassword/${grantType}`,
    method: 'post',
    data: params
  });
  return res;
};

/**
* 修改密码
* @param phone
* @param captcha
* @param newPassword
* @returns
*/
export const modifyPassword = async ({ phone, captcha, newPassword }, options) => {
  const res = await axios_({
    url: 'modifyPassword',
    method: 'post',
    data: {
      phone,
      captcha,
      newPassword: encrypt(newPassword),
    },
    ...options
  });
  return res.data;
};

export const forgetPassword = async ({ phone, captcha, newPassword }, options) => {
  const res = await axios_({
    url: 'forgetPassword',
    method: 'post',
    data: {
      phone,
      captcha,
      newPassword: encrypt(newPassword),
    },
    ...options
  });
  return res.data;
};

export const setLoginData = (data) => {
  clearAllLocalStorage();
  sessionStorage.setItem("loginData", typeof data === "object" ? JSON.stringify(data) : "{}");
};

export const removeLoginData = () => {
  sessionStorage.removeItem("loginData");
};

export const validatePrePhoneSMSCode = async (captcha) => {
  return await doGetRequest({
    url: '/api/organization/tenant/user/phone/preChange/check',
    params: {
      captcha
    }
  })
};

export const updatePhone = async (data) => {
  return await doPostRequest({
    url: '/api/organization/tenant/user/phone/change',
    data
  })
}

export const logout = async () => {
  return await doGetRequest({
    url: 'logout'
  });
}
